import { SDLUtil } from '@/utils';

export default {
  SET_PROJECT_COMBO_LIST(state, params) {
    state.projectComboList = params;
  },

  /* Main Mutations. start * */
  /* 프로젝트 목록 변이 * */
  SET_USER_PROJECT_LIST(state, payload) {
    state.userProjectList = payload.rows;
    state.currentPage = payload.currentPage;
    state.pageSize = payload.pageSize;
    state.pageUnit = payload.pageUnit;
    state.records = payload.records;
  },

  /* 프로젝트 상세 변이 * */
  SET_PROJECT_DETAIL(state, payload) {
    state.projectDetail = payload;
  },

  /* 프로젝트 CSP 목록 변이 * */
  SET_PROJECT_CSP_LIST(state, payload) {
    state.projectCspList = payload;
  },

  /* 프로젝트 환경(ENV) 변이 * */
  SET_PROJECT_ENVS(state, payload) {
    state.envTab = payload[0];
    state.projectEnvs = payload;
  },

  /* 환경(ENV) 탭값 변이 * */
  SET_TAB_ENV(state, payload) {
    state.envTab = payload;
  },

  /* 리소스 유저 목록 변이 * */
  SET_RESOURCE_USER_LIST(state, payload) {
    const userList = payload.rows;
    for (let i = 0; i < userList.length; i++) {
      // if(resourceUserList[i].acsTypeCd > 30) {
      if (userList[i].commonMemberCnt === 1 && userList[i].acsTypeCd > 30) {
        userList[i].isWriteIcon = true;
        // userGrpStatCd = 100(Approved) 외는 연필아이콘(수정) disabled.
      } else if (userList[i].userGrpStatCd !== 100) {
        userList[i].isWriteIcon = true;
      } else {
        userList[i].isWriteIcon = false;
      }
    }

    // state.resourceUserList = payload.rows;
    state.resourceUserList = userList;
    state.userCurrentPage = payload.currentPage;
    state.userPageSize = payload.pageSize;
    state.userPageUnit = payload.pageUnit;
    state.userRecords = payload.records;
  },

  /* 초기화 * */
  INIT_DATA(state, payload) {
    if (payload === 'ALL') {
      state.userProjectList = [];
      state.projectDetail = [];
      state.projectEnvs = [];
      state.envTab = [];
      state.resourceUserList = [];
    }

    if (payload === 'LEFT') {
      state.userProjectList = [];
    }

    if (payload === 'CENTER') {
      state.projectDetail = [];
      state.projectEnvs = [];
      state.envTab = [];
    }

    if (payload === 'RIGHT') {
      state.resourceUserList = [];
      state.userRecords = 0;
    }

    if (payload === 'RIGHT_CENTER') {
      state.resourceUserList = [];
      state.userRecords = 0;
      state.projectEnvs = [];
      state.projectDetail = [];
    }
  },
  /* Main Mutations. end * */

  /* Popup Mutations. start * */
  /* Common Resource(EC2, DBA) 프로젝트 유저 목록 변이 * */
  SET_SERVICE_MEMBERS_LIST(state, payload) {
    state.serviceMembersList = payload;
  },

  /* Common Resource(EC2, DBA) 전체 유저 목록 변이 * */
  SET_ALL_USER_LIST(state, payload) {
    state.allUserList = payload;
  },

  /* Popup Mutations. end * */
};



// WEBPACK FOOTER //
// ./src/vuex/rem/project/projectMutations.js